import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Route, Routes } from 'react-router-dom';
import Customers from '../customers/customer';
import './dashboard.css';
import Home from '../home/home';
import CustomerNew from '../customers/customer-create';
import CustomerDetails from '../customers/customer-details';
import SideNav from '../../components/sidenav';

const Dashboard: React.FC = () => {
  return (
    <Container fluid className="vh-100">
      <Row className="h-100">
        {/* Menú lateral */}
        <SideNav />

        {/* Contenido principal */}
        <Col md={9} className="content-area p-4">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/new" element={<CustomerNew />} />
            <Route path="/customers/:id/details" element={<CustomerDetails />} />
          </Routes>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
